/**
 * Default stage order (fallback when API hasn't been called yet).
 * Mirrors backend/app/seed/stage_mapping.csv display_order.
 */
const DEFAULT_STAGE_ORDER: string[] = [
  'In Exclusivity/DD',
  'Advanced Discussions / 2nd Round',
  'IOI / In Discussion',
  'NDA / Dataroom Review',
  'Opportunity Under Review',
  'New Opportunity / Early Dialogue',
  'Mapping',
];

/** API-provided stage order, set via setStageOrder(). */
let _dynamicOrder: string[] | null = null;

/** Update the stage order from the backend /api/stages response. */
export function setStageOrder(stages: string[]): void {
  _dynamicOrder = stages;
}

/** Current active stage order (API-driven if available, else default). */
export function getStageOrder(): string[] {
  return _dynamicOrder || DEFAULT_STAGE_ORDER;
}

/** Static export for backward compatibility. Prefer getStageOrder() for dynamic updates. */
export const STAGE_ORDER: string[] = DEFAULT_STAGE_ORDER;

/** Returns the sequential index for a stage string. Unknown stages sort to the end. */
export function stageIndex(stage: string): number {
  const order = _dynamicOrder || DEFAULT_STAGE_ORDER;
  const idx = order.indexOf(stage);
  return idx === -1 ? order.length : idx;
}
